var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgElevatorMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 677,
    viewBox: "0 0 375 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_704_17)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 677,
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 233.153,
    y: -56,
    width: 35.2465,
    height: 668.564,
    transform: "rotate(23.221 233.153 -56)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 278.974,
    y: -56,
    width: 10.9106,
    height: 783.465,
    transform: "rotate(23.221 278.974 -56)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112.153,
    y: -56,
    width: 10.9106,
    height: 426.482,
    transform: "rotate(23.221 112.153 -56)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 451.153,
    y: 349,
    width: 10.9106,
    height: 426.482,
    transform: "rotate(23.221 451.153 349)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 354.153,
    y: -56,
    width: 10.9106,
    height: 811.99,
    transform: "rotate(23.221 354.153 -56)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_704_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 677,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgElevatorMenu);
export default __webpack_public_path__ + "static/media/bg_elevatorMenu.b773e2e53a189176df5c1a0bb66bfeb8.svg";
export { ForwardRef as ReactComponent };